module.exports = __webpack_public_path__ + "img/125.398148d4.jpg";